const flags: any = import.meta.glob('/src/assets/flags/*.png', { eager: true });


const flagMap:any = {};
for (const path in flags) {
  const fileName = path.split('/').pop(); // ex: 'fr.png'
  if(fileName){
      const code:any = fileName.split('.')[0];   // ex: 'fr'
      if(code){
        flagMap[code] = flags[path].default;
      }
  }
}

export default flagMap;
